import React from 'react';
import { Users, BookOpen, Gift, Star } from 'lucide-react';
export function SocialProof() {
  const stats = [{
    icon: <Users className="w-5 h-5 text-sky-300" data-id="element-302" />,
    text: '+2.800 familias'
  }, {
    icon: <BookOpen className="w-5 h-5 text-sky-300" data-id="element-303" />,
    text: '6 Tomos listos'
  }, {
    icon: <Gift className="w-5 h-5 text-sky-300" data-id="element-304" />,
    text: '4 Bonos incluidos'
  }, {
    icon: <Star className="w-5 h-5 text-amber-400 fill-amber-400" data-id="element-305" />,
    text: '4.9/5 calificación ⭐'
  }];
  return <div className="bg-sky-900 border-y border-sky-800 py-6" data-id="element-306">
      <div className="container mx-auto px-4" data-id="element-307">
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 md:justify-between items-center max-w-5xl mx-auto" data-id="element-308">
          {stats.map((stat, i) => <div key={i} className="flex items-center gap-2 font-medium text-sky-50" data-id="element-309">
              {stat.icon}
              <span data-id="element-310">{stat.text}</span>
            </div>)}
        </div>
      </div>
    </div>;
}